import styled from "styled-components";
import {WP_CONTENT_PREFIX} from "../constants";

export const Overlay = styled.div`
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 4;
    background: url('${WP_CONTENT_PREFIX}/images/overlay-bg.png') no-repeat;
    background-size: contain;
    background-position: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${props => props.padding ? props.padding : '8vw'};
`;

export const Background = styled.div`
    position: fixed;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.7);
    z-index: 5;
    top: 0;
`;
